<template>
  <div>
    <el-select
      v-model="fieldId"
      remote
      clearable
      filterable
      reserve-keyword
      placeholder="请填写字段名称"
      :remote-method="remoteMethod"
      :loading="loading"
    >
      <el-option
        v-for="item in fieldNameList"
        :key="item.id"
        :label="item.fieldName"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
import { queryByFieldName } from '@/API/markManager.js';

export default {
  model: {
    prop: 'data',
    event: 'change'
  },

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      loading: false,
      fieldId: '',
      fieldNameList: []
    };
  },

  watch: {
    fieldId (newVal) {
      if (newVal === '') {
        this.$emit('change', newVal);
        return;
      }
      this.fieldNameList.some(item => {
        if (item.id === newVal) {
          this.$emit('change', item);
          return true;
        }
      });
    }
  },

  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        queryByFieldName({
          fieldName: query
        }).then(res => {
          this.loading = false;
          let json = res.data || {};
          if (json.status !== '200') return;
          this.fieldNameList = json.data || [];
        });
      } else {
        this.fieldNameList = [];
      }
    }
  }
};
</script>

<style scoped>

</style>
